var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"opacity-page"},[(_vm.notPaid)?_c('div',[_c('page-not-paid')],1):_c('div',[_vm._v(" DASHBOARD! ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }